import { takeLatest } from 'redux-saga/effects'

import { ADD_KB, FETCH_ALL_KB, FETCH_KB_SECTIONS, DELETE_KB, UPDATE_KB, SYNC_KB } from 'Actions/kb'
import { addKB, fetchAllKB, fetchKBSections, deleteKB, updateKB, syncKB } from './helpers/kb'

export default function* appSaga() {
  yield takeLatest(ADD_KB, addKB)
  yield takeLatest(FETCH_ALL_KB, fetchAllKB)
  yield takeLatest(FETCH_KB_SECTIONS, fetchKBSections)
  yield takeLatest(DELETE_KB, deleteKB)
  yield takeLatest(UPDATE_KB, updateKB)
  yield takeLatest(SYNC_KB, syncKB)
}
